import { _OBSOLETE_FUNCTION_WARNING_ } from '../../shared/functions';

export const loginAndBackgroundItemManagements = {
    create(data) {
        return $.ajax({
            method:      'POST',
            contentType: "application/json",
            dataType:    'json',
            data:        JSON.stringify({ loginAndBackgroundItemManagement: data }),
        		url:         AdminRoutes.adminLoginAndBackgroundItemManagementsPath()
				});
    },

    update(id, data) {
        return $.ajax({
            method:      'PUT',
            contentType: "application/json",
            dataType:    'json',
            data:        JSON.stringify({  loginAndBackgroundItemManagement: data }),
            url:         AdminRoutes.adminLoginAndBackgroundItemManagementPath(id)
        });
    },

    delete(id) {
        return $.ajax({
            method:      'DELETE',
            contentType: "application/json",
            dataType:    'json',
            url:         AdminRoutes.adminLoginAndBackgroundItemManagementPath(id)
        });

    },

    duplicate(id) {
        return $.ajax({
            method:      'POST',
            contentType: "application/json",
            dataType:    'json',
            url:         AdminRoutes.duplicateAdminLoginAndBackgroundItemManagementPath(id)
        });
    }
};

export const deviceLoginAndBackgroundItemManagements = {
    create(deviceId, data) {
        return $.ajax({
            method:      'POST',
            contentType: "application/json",
            dataType:    'json',
            data:        JSON.stringify({ loginAndBackgroundItemManagement: data }),
        		url:         AdminRoutes.adminDeviceLoginAndBackgroundItemManagementsPath(deviceId)
   		  });
    },

    update(deviceId, id, data) {
        return $.ajax({
            method:      'PUT',
            contentType: "application/json",
            dataType:    'json',
            data:        JSON.stringify({  loginAndBackgroundItemManagement: data }),
            url:         AdminRoutes.adminDeviceLoginAndBackgroundItemManagementPath(deviceId, id)
        });
    },

    delete(deviceId, id) {
        return $.ajax({
            method:      'DELETE',
            contentType: "application/json",
            dataType:    'json',
            url:         AdminRoutes.adminDeviceLoginAndBackgroundItemManagementPath(deviceId, id)
        });

    },

    duplicate(deviceId, id) {
        return $.ajax({
            method:      'POST',
            contentType: "application/json",
            dataType:    'json',
            url:         AdminRoutes.duplicateAdminDeviceLoginAndBackgroundItemManagementPath(deviceId, id)
        });
    }
};

export const groupLoginAndBackgroundItemManagements = {
    create(groupId, data) {
        return _OBSOLETE_FUNCTION_WARNING_("groupLoginAndBackgroundItemManagements#create", {groupId, data});
    },

    update(groupId, id, data) {
        return _OBSOLETE_FUNCTION_WARNING_("groupLoginAndBackgroundItemManagements#update", {groupId, id, data});
    },

    delete(groupId, id) {
        return _OBSOLETE_FUNCTION_WARNING_("groupLoginAndBackgroundItemManagements#delete", {groupId, id});
    },

    duplicate(groupId, id) {
        return _OBSOLETE_FUNCTION_WARNING_("groupLoginAndBackgroundItemManagements#duplicate", {groupId, id});
    }
};

export const allLoginAndBackgroundItemManagements = {
  default: loginAndBackgroundItemManagements,
  device: deviceLoginAndBackgroundItemManagements,
  group: groupLoginAndBackgroundItemManagements
}
